import { render } from "./ProjectGallery.vue?vue&type=template&id=33d03c3c&scoped=true"
import script from "./ProjectGallery.vue?vue&type=script&lang=ts"
export * from "./ProjectGallery.vue?vue&type=script&lang=ts"

import "./ProjectGallery.vue?vue&type=style&index=0&id=33d03c3c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-33d03c3c"

export default script